import axios from "axios";
import { permissionInputParts } from "@/composables/datasetPermissions";
import { withPrefix } from "@/utils/redirect";
export function getPermissionsUrl(historyId) {
    return `/history/permissions?id=${historyId}`;
}
export function getPermissions(historyId) {
    const permissionsUrl = getPermissionsUrl(historyId);
    return axios.get(withPrefix(permissionsUrl));
}
export function setPermissions(historyId, formContents) {
    const permissionsUrl = getPermissionsUrl(historyId);
    return axios.put(withPrefix(permissionsUrl), formContents);
}
export function makePrivate(historyId, permissionResponse) {
    const { manageInput } = permissionInputParts(permissionResponse.inputs);
    const managePermissionValue = manageInput.value[0];
    const access = [managePermissionValue];
    const formValue = {
        DATASET_MANAGE_PERMISSIONS: [managePermissionValue],
        DATASET_ACCESS: access,
    };
    return setPermissions(historyId, formValue);
}
export async function isHistoryPrivate(permissionResponse) {
    const { accessInput } = permissionInputParts(permissionResponse.inputs);
    return accessInput.value.length >= 1;
}
